import React from 'react';
import { Box } from '@mui/material';
import SiteFooter from './components/SiteFooter';
import AboutHero from './components/AboutHero';
import PropertyStory from './components/PropertyStory';
import GuestHighlights from './components/GuestHighlights';
import Accommodations from './components/Accommodations';
import Location from './components/Location';
import PracticalInfo from './components/PracticalInfo';
import FeaturesExtended from './components/FeaturesExtended';
import { useScrollSpyHash } from '../../common/hooks/useScrollSpyHash';

const ABOUT_SECTION_IDS = [
  'about-hero',
  'property-story',
  'guest-highlights',
  'accommodations',
  'features-extended',
  'location',
  'practical-info',
];

const AboutPage = () => {
  useScrollSpyHash(ABOUT_SECTION_IDS);

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#fafafa' }}>
      <AboutHero id="about-hero" />
      <PropertyStory id="property-story" />
      <GuestHighlights id="guest-highlights" />
      <Accommodations id="accommodations" />
      <FeaturesExtended id="features-extended" />
      <Location id="location" />
      <PracticalInfo id="practical-info" />
      <SiteFooter />
    </Box>
  );
};

export default AboutPage;
